import { Tooltip, TooltipProps } from '@mui/material';

export const OptionalTooltip: React.FC<TooltipProps> = ({
  children,
  ...tooltipProps
}) => (
  <Tooltip {...tooltipProps}>
    <span>{children}</span>
  </Tooltip>
);
